import { Link } from 'react-router-dom';
import './footer-list.styles.css';

const FooterList = ({ cat }) => {
    const { title, items } = cat;

    return (
        <ul className="footer-list">
            <h4 className="footer-list-title">{title}</h4>
            {items.map((item, index) => (
                <li className="footer-list-item" key={index}>
                    <Link className="footer-list-item-link" to={item.link}>
                        {item.text}
                        <span className="footer-link-under-line"></span>
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default FooterList;
